export const getAllGraphStepChildrenIds = (graph, stepId, array = []) => {
  const step = graph[stepId];
  if (step?.exit && !array.includes(step.exit)) {
    array.push(step.exit);
    getAllGraphStepChildrenIds(graph, step.exit, array);
  }
  if (step?.child && !array.includes(step.child)) {
    array.push(step.child);
    getAllGraphStepChildrenIds(graph, step.child, array);
  }
  if (step?.branches) {
    for (let i = 0; i < step.branches.length; i++) {
      if (!array.includes(step.branches[i])) {
        array.push(step.branches[i]);
        getAllGraphStepChildrenIds(graph, step.branches[i], array);
      }
    }
  }
  return array;
};
